import React from "react"
import style from './style.module.scss'
import { WithOverrides } from "./withOverrides"
import { ReactComponent as ClearIcon } from '../../../../assets/svg/Group 5.svg'
import { ReactComponent as AddIcon } from '../../../../assets/svg/Group 38036.svg'
import { ReactComponent as AgentIcon } from '../../../../assets/svg/Group 18.svg'
import { Icon, Spin } from "antd"
import { KnowledgeBaseProps } from "./types"
import { pageVariants } from "./framerAnimations"
import { motion } from "framer-motion"


export const KnowledgeBaseAgents = (props: KnowledgeBaseProps) => {

    const antIcon = <Icon type="loading" style={{ fontSize: 30 }} spin={true} />
    const { app, agents, loading, onSelectAgent, updateActions } = props || {}

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={pageVariants}>
            {!loading ? <WithOverrides >
                <h1 className={style.agentText}>Active Agents</h1>
                {app?.aiAgents?.length > 0 ?
                    <div className={style.agents}>
                        {agents.map((agent, index) => {
                            return (
                                <>
                                    {app.aiAgents && app.aiAgents.includes(agent.id) &&
                                        <div key={agent.id}
                                            onMouseEnter={() => { updateActions(true, index, "remove") }}
                                            onMouseLeave={() => { updateActions(false, index, "remove") }}
                                            onClick={() => onSelectAgent(agent.id)}
                                            className={style.activeAgent}
                                        >
                                            <span className={style.agentTxt} key={agent.id}>{agent.name}</span>
                                            {agent.removeAgent &&
                                                <div
                                                    className={style.icon}
                                                    onClick={() => onSelectAgent(agent.id)}
                                                >
                                                    <ClearIcon />
                                                </div>
                                            }
                                        </div>}
                                </>
                            )
                        })}
                    </div>
                    :
                    <div className={style.noAgentOuterLayer}>
                        <div className={style.agentIcon}>
                            <AgentIcon />
                        </div>
                        <p className={style.noAgentTxt}>You have not added any agent yet. Select agent
                            from inactive agent section</p>
                    </div>}


                <h1 className={style.agentText}>Inactive Agents</h1>
                <div className={style.agents}>
                    {agents.map((agent, index) => {
                        return (
                            <>
                                {!app?.aiAgents?.includes(agent.id) && <div key={agent.id}
                                    onMouseEnter={() => { updateActions(true, index, "add") }}
                                    onMouseLeave={() => { updateActions(false, index, "add") }}
                                    className={style.inActiveAgent}
                                >
                                    <span className={style.agentTxt} key={agent.id}>{agent.name}</span>
                                    {agent.addAgent &&
                                        <div
                                            className={style.icon}
                                            onClick={() => onSelectAgent(agent.id)}
                                        >
                                            <AddIcon />
                                        </div>
                                    }
                                </div>}
                            </>
                        )
                    })}
                </div>
            </WithOverrides>
                :
                <div className={style.loadingContainer}>
                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                </div>
            }
        </motion.div>
    )
}